import { QUEUE_SYMBOLS } from "@/game-lol/constants/constants.mjs";
import { QUEUE_SYMBOL_TO_OBJECT } from "@/game-lol/utils/symbol-queue.mjs";
import { getDerivedQueue } from "@/game-lol/utils/util.mjs";

export const CURR_SEASON_PROMO = 14;
export const FINAL_PROMO_DATE = 1738195200; // Feb, 30th 2025
export const DISMISSED_KEY = "seasonReview2024Dismissed";
export const VIEWED_KEY = "seasonReview2024Viewed";
export const EVENT_SEASON_REVIEW_PROMO_CLICK =
  "EVENT_SEASON_REVIEW_PROMO_CLICK";
export const MIN_QUEUE_GAMES = 5;

export const SUPPORTED_QUEUES = [
  {
    symbol: QUEUE_SYMBOLS.rankedSoloDuo,
    enum: QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.rankedSoloDuo].gql,
    stateKey: (derivedId) =>
      getDerivedQueue(
        derivedId,
        QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.rankedSoloDuo].gql,
      ),
  },
  {
    symbol: QUEUE_SYMBOLS.rankedFlex,
    enum: QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.rankedFlex].gql,
    stateKey: (derivedId) =>
      getDerivedQueue(
        derivedId,
        QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.rankedFlex].gql,
      ),
  },
  {
    symbol: QUEUE_SYMBOLS.aram,
    enum: QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.aram].gql,
    stateKey: (derivedId) =>
      getDerivedQueue(
        derivedId,
        QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.aram].gql,
      ),
  },
];
